import { Component, Input } from '@angular/core';
import { DatasetFileTypeOption } from '@ca/core/models';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ca-dataset-file-removal-confirmation-dialog',
    templateUrl: './dataset-file-removal-confirmation-dialog.component.html',
    styleUrls: ['./dataset-file-removal-confirmation-dialog.component.scss'],
})
export class DatasetFileRemovalConfirmationDialogComponent {
    @Input() numberOfFiles = 0;
    @Input() datasetFileTypeOption = DatasetFileTypeOption.FILES;

    readonly datasetFileTypeOptionEnum = DatasetFileTypeOption;

    constructor(private translate: TranslateService) {}

    deleteMessage: string =
        this.datasetFileTypeOption === this.datasetFileTypeOptionEnum.ANNOTATIONS
            ? this.numberOfFiles > 0
                ? this.translate.instant('MACHINE_LEARNING.ANNOTATE.CONFIRM_DELETE_ANNOTATION_FILE')
                : this.translate.instant('MACHINE_LEARNING.ANNOTATE.CONFIRM_DELETE_ANNOTATION_FILES')
            : this.numberOfFiles > 0
              ? this.translate.instant('MACHINE_LEARNING.ANNOTATE.CONFIRM_DELETE_IMAGE_FILE')
              : this.translate.instant('MACHINE_LEARNING.ANNOTATE.CONFIRM_DELETE_IMAGE_FILES');
}
